import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Box} from "@mui/material";
import './style.css'
import Button from "@mui/material/Button";
import {Head, Loading} from "../../components";
import Api from "../../utils/api";
import { useParams } from "react-router-dom";


const ContractView = (props) => {

    
    const { id } = useParams();

    const [form, setForm] = useState({});
    const [loading, setLoading] = useState({});

    useEffect(() => {
        handleRequest();
    }, []);

    const handleRequest = () => {
        setLoading(true);

        new Api().get('/marketers/contract/list/' + id, form).then((response) => {
            if (typeof response !== "undefined") {
                setForm(response)
            }

            setLoading(false);
        })
    }




    return(
        <Container>
            <Head data={{ 'link': '/contract', 'title': ' قرارداد' }} />
            <Box className={'contract-form'}>
                <form>
                    <div className={'section-to-print'}>
                    <div dangerouslySetInnerHTML={{__html:form?.details?.body}}/>
                    </div>
                </form>
            </Box>
            <Button disabled={loading} onClick={() => window.print()} variant={"contained"} color={"secondary"}>پرینت</Button>&nbsp;
            {loading && <Loading />}
        </Container>
    );
}


export default ContractView;